const DEFAULT_CHUNK_SIZE = 200 * 1024;

export function chunkBase64(
  base64: string,
  chunkSize: number = DEFAULT_CHUNK_SIZE,
): string[] {
  if (!Number.isFinite(chunkSize) || chunkSize <= 0) {
    throw new Error(`chunkSize must be a positive number, got ${chunkSize}`);
  }

  const chunks: string[] = [];
  for (let i = 0; i < base64.length; i += chunkSize) {
    chunks.push(base64.slice(i, i + chunkSize));
  }
  return chunks;
}
